import { render, staticRenderFns } from "./MatchHistoryRouterView.vue?vue&type=template&id=68b40510&scoped=true&"
import script from "./MatchHistoryRouterView.vue?vue&type=script&lang=js&"
export * from "./MatchHistoryRouterView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68b40510",
  null
  
)

export default component.exports